import React from 'react'
import { Box } from '@mui/joy'
import JSONPretty from 'react-json-pretty'
import { useFormatter } from '../../utils';

const CellAudienceCheck = ({ value, type = 'simple' }) => {

    const { formatDatetime } = useFormatter()

    return (
        <Box className={"list-element-cell cell-" + type}>
            {
                formatDatetime(value.check_at)
            }
        </Box>
    )
}

export default CellAudienceCheck